import React from 'react'
import { UseFormSetValue } from 'react-hook-form'
import { Box, Flex, Label, Checkbox, Text } from 'pcln-design-system'
import { useRouter } from 'next/router'
import { Discount } from 'pcln-icons'
import analytics from '@/shared-utils/analytics'
import { ProductOption } from '../Flights/types'

type BundleAndSaveType = {
  category: string
  productOptions: Readonly<ProductOption[]>
  tripType: string
  label: string
  setValue: UseFormSetValue<any>
}

export default function BundleAndSave({
  category,
  productOptions,
  tripType,
  label,
  setValue
}: BundleAndSaveType) {
  const {
    query: { tab = 'hotels' },
    pathname
  } = useRouter()
  const isHomepage = pathname === '/'
  const parent = isHomepage && typeof tab === 'string' ? `${tab}-` : ''
  const onBundleTypeSelection = (
    e: React.ChangeEvent<HTMLInputElement>,
    option: ProductOption
  ): void => {
    let value
    if (e.target.checked) {
      value = `${tripType}:${option.type}`
      analytics.fireEvent({
        action: 'Add Product Checkbox',
        category,
        label: `${parent}${option.label}`
      })
    } else {
      value = tripType.replace(`:${option.type}`, '')
    }
    setValue('tripType', value)
  }

  return (
    <Flex
      p={1}
      borderRadius="lg"
      height="100%"
      color="highlight.light"
      alignItems="center"
    >
      <Flex>
        <Discount
          m={1}
          mr={2}
          color={isHomepage ? 'highlight.shade' : 'success.dark'}
        />
        <Text
          pr={[1, 2, null, 3]}
          color={isHomepage ? 'highlight.shade' : 'success.dark'}
          bold
          fontSize={[0, null, null, null, 1]}
          m="auto"
          ml={0}
        >
          {label}
        </Text>
      </Flex>
      <Flex style={{ flex: '1 0 auto' }} flexWrap="wrap" alignItems="center">
        {productOptions.map(option => {
          const checked = tripType.includes(option.type)
          return (
            <Box key={option.name} mt="2px" pr={[1, 2]}>
              <Label
                fontSize={0}
                htmlFor={option.id}
                color="text.base"
                fontWeight="normal"
              >
                <Checkbox
                  aria-label={option.label}
                  id={option.id}
                  data-testid={option.id}
                  name={option.name}
                  value={option.type}
                  checked={checked}
                  unselectedColor="text.base"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    onBundleTypeSelection(e, option)
                  }
                />
                {` ${option.label} `}
              </Label>
            </Box>
          )
        })}
      </Flex>
    </Flex>
  )
}
